/**
 * Custom sorting function for an array of strings with an optional special item.
 *
 * @param {string[]} arr - The array of strings to sort.
 * @param {string | undefined} specialItem - An optional special item to prioritize in the sorting.
 * @returns {string[]} A sorted array of strings with the special item, if provided, appearing first.
 */
export const customSort = (arr: string[], specialItem?: string) => {
  return arr.sort((a, b) => {
    // Check if 'a' is the special item
    if (a === specialItem) return -1;
    // Check if 'b' is the special item
    if (b === specialItem) return 1;
    // Compare strings using default alphabetical order
    if (a < b) return -1;
    if (a > b) return 1;
    // If strings are equal, return 0
    return 0;
  });
};
